import React from "react";
import Components from "../../components";
import { useLocation } from "react-router-dom";

const Search = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Ara"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Search
        id="search"
        label="Search"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Search;
